import request from '../../../util/APIUtils';
import { GATEWAY_BASE_URL } from '../../../constants';
import { CategoryType } from '../constants';

/**
 * Fetch categories optionally filtered by type.
 * @param {string} [type] - Optional category type (BEST, SERVICE, PROGRAM).
 * @returns {Promise<Array>} List of categories
 */
export const fetchCategories = async (type) => {
  if (type && !Object.values(CategoryType).includes(type)) {
    const validTypes = Object.values(CategoryType).join(', ');
    throw new Error(`Invalid category type: ${type}. Valid types are: ${validTypes}`);
  }

  const url = `${GATEWAY_BASE_URL}/categories${type ? `?type=${type}` : ''}`;

  return request({
    url,
    method: 'GET',
    throw400Error: true
  });
};

